<template>
    <v-modal @opened="fetchData">
        <v-loading :data="PreOrderDeliveryMomentTotals"></v-loading>
        <slot slot="title">{{ $t('preorder.totals_per_delivery_moment') }}</slot>
        <slot slot="buttonContent">
            <v-block type="icon-block" height="stretch" color="white">
                <svgicon class="u-opacity-25" name="delivery" width="36" height="36"></svgicon>
                <p>{{ $t('preorder.delivery_moments') }}</p>
            </v-block>
        </slot>
        <div class="c-targets o-gutter">
            <div class="c-table-wrapper">

                <template v-for="(delivery) in PreOrderDeliveryMomentTotals">
                    <h3 class="u-text-align-center">{{ $t('global.delivery')}} {{ delivery.DeliveryDate | moment('DD-MM-YYYY') }}</h3>
                    <table-component class="o-page-row" table-class="c-table c-table--small" :data="delivery.Totals" :show-caption="false" :show-filter="false">
                        <table-column key="SubGroup" :label="$t('preorder_subgroup_totals.columns.subgroup')" :sortable="false">
                            <template slot-scope="row">
                                {{row["SubGroup"]}}
                            </template>
                        </table-column>
                        <table-column key="Amount" :label="$t('preorder.product_variant_count')" :sortable="false">
                            <template slot-scope="row">
                                {{row["Amount"]}}
                            </template>
                        </table-column>
                        <table-column key="Total" :label="$t('global.total')" :sortable="false">
                            <template slot-scope="row">
                                {{ row["Total"] | currency(customerCurrencySymbol) }}
                            </template>
                        </table-column>
                    </table-component>
                </template>   
            </div> 
            <p>Opgelet! De vermelde totalen zijn indicatief.</p>   
        </div>        
    </v-modal>
</template>

<script>
    import VModal from '@/components/modal/Modal'
    import VBlock from '@/components/blocks/Block'
    import VLoading from '@/components/Loading'

    // Store
    import {mapGetters} from 'vuex'

    export default {
        components: {
            VModal,
            VBlock,
            VLoading
        },
        props: {
        },
        computed: {
            ...mapGetters({
                PreOrderDeliveryMomentTotals: 'PreOrderDeliveryMomentTotals'
            }),
            customerCurrencySymbol() { 
                return this.$store.getters.userInfo.customerCurrencySymbol;
            }
        },
        methods: {
            fetchData() {
                this.$store.dispatch('getPreOrderDeliveryMomentTotals', this.$route.params.id);              
            }
        }
    }
</script>

<style lang="scss" scoped>

    @import "~@/assets/scss/private";

</style>


// WEBPACK FOOTER //
// src/components/modal/common/DeliveryMomentTotals.vue